import React from 'react';
import AffiliateDetailContainer from '@src/containers/AffiliateDetail';

const AffiliateDetail = () => <AffiliateDetailContainer />;

export default AffiliateDetail;
